module.exports = __webpack_public_path__ + "img/youtube.00d14816.svg";